module.exports = __webpack_public_path__ + "static/music-republicain-1-976aeb51b4c4fb05037929037bd24954.jpg";